import { apiTelemedicine } from '../api';
import { FetchAcceptTermsDataBody } from '../types';

export const acceptTermsPatientTelemedicine = (
  data: FetchAcceptTermsDataBody,
) => apiTelemedicine.post('accept-service-terms/patient', data);
